import { object, string } from 'yup';
const loginValidation = object().shape({
  email: string().email('validations.email.format').required('validations.email.required'),
  password: string().required('validations.password.required')
});
export default loginValidation;